module.exports = __webpack_public_path__ + "static/media/index.9022da45.cjs";